
export let reducer = (state = "") => {
  return state;
};

export default reducer;
